export default __webpack_public_path__ + "static/media/profile3.7fd545ce.jpg";